import React from 'react';
import PropTypes from 'prop-types';

import general from './style/general.module.css';

export default function NavItemWithTitle({ title, description }) {
  return (
    <div className={general.container}>
      <div className={general.title}>{title}</div>
      <div className={general.description}>{description}</div>
    </div>
  );
}

NavItemWithTitle.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/HeaderNav/NavItemWithTitle/index.js